document.addEventListener('DOMContentLoaded', function() {
  function updateWishlistIcon() {
    if (window._swat) {
      window._swat.fetchLists({
        callbackFn: function(lists) {
          let wishlistProducts = [];
          lists.forEach(function(list) {
            if (list.lty === "wl" && list.listcontents) {
              wishlistProducts = wishlistProducts.concat(list.listcontents);
            }
          });
          
          const wishlistIcon = document.getElementById('wishlist-icon-bubble');
          if (!wishlistIcon) return;
          
          if (wishlistProducts && wishlistProducts.length > 0) {
            wishlistIcon.classList.add('has-items');
            const countSpan = wishlistIcon.querySelector('.wishlist-count-bubble span[aria-hidden="true"]');
            if (countSpan) {
              countSpan.textContent = wishlistProducts.length;
            }
          } else {
            wishlistIcon.classList.remove('has-items');
            const countSpan = wishlistIcon.querySelector('.wishlist-count-bubble span[aria-hidden="true"]');
            if (countSpan) {
              countSpan.textContent = '0';
            }
          }
        }
      });
    }
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(updateWishlistIcon);
  
  document.addEventListener('swym:variant-change', updateWishlistIcon);
  document.addEventListener('swym:wishlist-change', updateWishlistIcon);
  document.addEventListener('swym:load', updateWishlistIcon);
  document.addEventListener('swym:remove', updateWishlistIcon);
  document.addEventListener('swym:add', updateWishlistIcon);
});
